<div class="fixed inset-0 z-50 flex items-start justify-center bg-black/40 overflow-y-auto p-4" role="dialog" aria-modal="true"
     [attr.aria-label]="relatorio.name">
  <div class="w-full max-w-xl mt-10 bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-[#E5DFD4] dark:border-gray-700"
       (keydown.enter)="aoTeclarEnter($any($event), $event.target)">
    <div class="px-6 py-4 bg-[var(--brand-primary)] rounded-t-2xl flex items-center justify-between">
      <span class="font-semibold text-sm text-white">#{{ relatorio.id }} · {{ relatorio.name }}</span>
      <button type="button" class="text-white text-lg leading-none" aria-label="Fechar" (click)="fechar.emit()">✕</button>
    </div>

    <div class="px-6 py-5 flex flex-col gap-4">
      <p *ngIf="!params.length" class="text-xs text-gray-600 dark:text-gray-400">Este relatório não requer parâmetros.</p>

      <ng-container *ngFor="let p of params">
        <div *ngIf="visivel(p)" class="flex flex-col gap-1">
          <label [attr.for]="'param-' + p.name" class="text-xs font-semibold text-gray-900 dark:text-gray-100">
            {{ p.label }}<span *ngIf="p.required" class="text-red-600"> *</span>
          </label>

          <ng-container *ngIf="ehSelecao(p); else naoSelecao">
            <app-lista-selecao [itens]="opcoes[p.name]?.itens ?? []" [valor]="valores[p.name]" [comBusca]="true"
                               [desabilitado]="!(opcoes[p.name]?.itens?.length)"
                               [placeholder]="opcoes[p.name]?.aviso || 'Selecione...'" [rotuloAcessivel]="p.label"
                               (escolher)="alterar(p, $event)"></app-lista-selecao>
            <span *ngIf="opcoes[p.name]?.aviso && opcoes[p.name]?.itens?.length" class="text-[11px] text-gray-500">{{ opcoes[p.name]?.aviso }}</span>
          </ng-container>

          <ng-template #naoSelecao>
            <ng-container [ngSwitch]="p.type">
              <div *ngSwitchCase="'checkbox-list'" [id]="'param-' + p.name"
                   class="max-h-48 overflow-y-auto rounded-lg border border-[#E5DFD4] dark:border-gray-600 p-2 flex flex-col gap-1">
                <span *ngIf="opcoes[p.name]?.aviso" class="text-xs text-gray-500">{{ opcoes[p.name]?.aviso }}</span>
                <label class="flex items-center gap-2 text-xs text-gray-900 dark:text-gray-100">
                  <input type="checkbox" [checked]="todos[p.name]" (change)="alternarTodos(p, $any($event.target).checked)"/> Todos
                </label>
                <label *ngFor="let it of opcoes[p.name]?.itens ?? []" class="flex items-center gap-2 text-xs text-gray-900 dark:text-gray-100">
                  <input type="checkbox" [checked]="marcados[p.name].has(it.valor)" (change)="alternarItem(p, it.valor, $any($event.target).checked)"/>
                  {{ it.rotulo }}
                </label>
              </div>

              <ng-container *ngSwitchCase="'datalist'">
                <input [id]="'param-' + p.name" type="text" [attr.list]="'datalist-' + p.name" autocomplete="off"
                       [placeholder]="p.placeholder || 'Selecione ou digite...'"
                       [ngModel]="valores[p.name]" (ngModelChange)="alterar(p, $event)"
                       class="w-full px-3 py-2 text-sm rounded-lg border border-[#E5DFD4] dark:border-gray-600 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700"/>
                <datalist [id]="'datalist-' + p.name">
                  <option *ngFor="let s of sugestoes(p)" [value]="s"></option>
                </datalist>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <input [id]="'param-' + p.name" [type]="tipoDoInput(p)" autocomplete="off" [placeholder]="placeholder(p)"
                       [ngModel]="valores[p.name]" (ngModelChange)="alterar(p, $event)"
                       (blur)="temPreviaDeCpf(p) && aoSairDoCpf(p)"
                       class="w-full px-3 py-2 text-sm rounded-lg border border-[#E5DFD4] dark:border-gray-600 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-700"/>
                <div *ngIf="previas[p.name] as pv" aria-live="polite"
                     class="rounded px-3 py-2 text-xs"
                     [ngClass]="{
                       'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300': pv.estado === 'buscando',
                       'bg-green-50 text-green-800 dark:bg-green-900/30 dark:text-green-200': pv.estado === 'achou',
                       'bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-200': pv.estado === 'nao-achou' || pv.estado === 'erro'
                     }">{{ pv.texto }}</div>
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </ng-container>

      <div *ngIf="erroValidacao" class="rounded-lg px-3 py-2 text-xs bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-200">
        {{ erroValidacao }}
      </div>
      <div *ngIf="mensagem" aria-live="polite" class="rounded-lg px-3 py-2 text-xs border"
           [ngClass]="{
             'bg-red-50 border-red-200 text-red-800 dark:bg-red-900/30 dark:border-red-800 dark:text-red-200': tipoMensagem === 'erro',
             'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-900/30 dark:border-amber-800 dark:text-amber-200': tipoMensagem === 'aviso',
             'bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-200': tipoMensagem === 'info'
           }">{{ mensagem }}</div>
    </div>

    <div class="px-6 py-4 border-t border-[#E5DFD4] dark:border-gray-700 flex justify-end gap-2">
      <button type="button" (click)="fechar.emit()"
              class="px-4 py-2 rounded-lg text-xs font-semibold border border-[#E5DFD4] dark:border-gray-600 text-gray-900 dark:text-gray-100">Fechar</button>
      <button type="button" data-acao="gerar" [disabled]="gerando" (click)="enviar()"
              class="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5 bg-[#00AC70] hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed">
        <span *ngIf="gerando" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></span>
        {{ gerando ? 'Gerando…' : 'Gerar' }}
      </button>
    </div>
  </div>
</div>
